import { render, staticRenderFns } from "./levelPrice.vue?vue&type=template&id=547855b3"
import script from "./levelPrice.vue?vue&type=script&lang=js"
export * from "./levelPrice.vue?vue&type=script&lang=js"
import style0 from "./levelPrice.vue?vue&type=style&index=0&id=547855b3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports